import React, { useState } from "react";

import {
  Smartphone,
  Store,
  BadgeDollarSign,
  ChevronDown,
  ChevronUp,
  ShieldCheck,
  ArrowLeft,
  Users,
  MapPin,
  Phone,
  Send,
} from "lucide-react";

import "../Styles/MobileTopup.css";

import VendorFormModal from "../components/VendorFormModal";

import { useNavigate } from "react-router-dom";

const MobileTopup = () => {

  const [expanded, setExpanded] =
    useState(false);

  const [showVendorForm, setShowVendorForm] =
    useState(false);

  const navigate = useNavigate();

  const vendors = [

    {
      alias: "Avis Retemiah",
      product: "Top-Up",
      number: "+592 633 0786",
      location: "Arthurville Wakenaam",
    },

    {
      alias: "Chabi Laylys",
      product: "Top-Up",
      number: "+592 682 3136",
      location: "Noitgedacht Wakenaam",
    },

    {
      alias: "Sharmele Singh",
      product: "Top-Up",
      number: "+592 691 4264",
      location: "Melville Wakenaam",
    },

    {
      alias: "Hameraj & Sons",
      product: "Phone Cards",
      number: "+592 669-1025",
      location: "MeerZorg Wakenaam",
    },

    {
      alias: "Mokesh Grocery",
      product: "Phone Cards",
      number: "+592 698 5772",
      location: "Zeelandia Wakenaam",
    },

      {
      alias: "Devina's",
      product: "Phone Cards",
      number: "Not Available",
      location: "Caledonia Wakenaam",
    },

    {
      alias: "Navita Services",
      product: "Top-Up",
      number: "+592 673 9707",
      location: "Maria’s Pleasure Wakenaam",
    },

      {
      alias: "Babes General Store",
      product: "Phone Cards",
      number: "Not Available",
      location: "Belle Plaine Wakenaam",
    },

  {
      alias: "Cindy Grocery",
      product: "Top-Up",
      number: "Not Available",
      location: "Melville Wakenaam",
    },

    {
      alias: "A&C General Store",
      product: "Phone Cards",
      number: "Not Available",
      location: "18 Belle Plaine Wakenaam",
    },

    {
      alias: "NK Jairam General Store",
      product: "Phone Cards",
      number: "Not Available",
      location: "16 Belle Plaine Wakenaam",
    },
      {
      alias: "Khan's General Store",
      product: "Phone Cards",
      number: "Not Available",
      location: "Good Success Wakenaam",
    },

  ];

  const visibleRows = expanded
    ? vendors
    : vendors.slice(0, 5);

  return (

    <div className="modern-topup-page">

      {/* HERO */}
      <section className="modern-topup-hero">

        <div className="modern-topup-overlay" />

        <div className="modern-topup-content">

          <button
            className="modern-topup-back-btn"
            onClick={() =>
              navigate("/services")
            }
          >

            <ArrowLeft size={18} />
            Back To Services

          </button>

          <div className="modern-topup-badge">
            MOBILE SERVICES
          </div>

          <h1 className="modern-topup-heading">
            Mobile Top-Up
            <span> & Phone Cards</span>
          </h1>

          <p className="modern-topup-text">
            Retail and wholesale top-up
            solutions for Digicel,
            One Communications and Enet,
            alongside phone card services
            throughout Wakenaam.
          </p>

        </div>

      </section>

      {/* INFO CARDS */}
      <section className="modern-topup-info-grid">

        <div className="modern-topup-info-card">

          <div className="modern-topup-icon">
            <Smartphone size={34} />
          </div>

          <h3>
            Mobile Top-Up
          </h3>

          <p>
            Fast and reliable retail
            and wholesale top-up services
            across multiple networks.
          </p>

        </div>

        <div className="modern-topup-info-card">

          <div className="modern-topup-icon">
            <BadgeDollarSign size={34} />
          </div>

          <h3>
            Wholesale Services
          </h3>

          <p>
            Competitive wholesale rates
            for vendors and resellers
            across Wakenaam.
          </p>

        </div>

        <div className="modern-topup-info-card">

          <div className="modern-topup-icon">
            <ShieldCheck size={34} />
          </div>

          <h3>
            Trusted Distribution
          </h3>

          <p>
            Authorized services for
            Digicel, One Communications
            and Enet products.
          </p>

        </div>

      </section>

      {/* VENDORS */}
      <section className="modern-vendor-section">

        <div className="modern-vendor-header">

          <div className="modern-vendor-badge">
            VENDOR NETWORK
          </div>

          <h2>
            Island-Wide Vendor Access
          </h2>

          <p>
            RCS continues to grow its
            vendor network throughout
            Wakenaam for customer
            convenience and accessibility.
          </p>

        </div>

        <div className="modern-vendor-table-wrap">

          <table className="modern-vendor-table">

            <thead>

              <tr>
                <th>Vendor</th>
                <th>Service</th>
                <th>Contact</th>
                <th>Location</th>
              </tr>

            </thead>

            <tbody>

              {visibleRows.map((v, i) => (

                <tr key={i}>

                  <td>
                    <div className="vendor-name">
                      <Store size={16} />
                      {v.alias}
                    </div>
                  </td>

                  <td>{v.product}</td>

                  <td>{v.number}</td>

                  <td>
                    <div className="vendor-location">
                      <MapPin size={14} />
                      {v.location}
                    </div>
                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

        <button
          className="modern-expand-btn"
          onClick={() =>
            setExpanded(!expanded)
          }
        >

          {expanded ? (
            <>
              <ChevronUp size={18} />
              View Less
            </>
          ) : (
            <>
              <ChevronDown size={18} />
              View More
            </>
          )}

        </button>

      </section>

      {/* SIGNUP */}
      <section className="modern-vendor-signup">

        <div className="modern-signup-card">

          <div className="modern-signup-left">

            <div className="modern-signup-icon">
              <Users size={40} />
            </div>

            <h2>
              Become A Vendor
            </h2>

            <p>
              Join the RCS reseller
              network and gain access
              to wholesale pricing,
              financing opportunities
              and dedicated support.
            </p>

            <div className="modern-signup-note">

              PLEASE HAVE YOUR ID,
              TIN OR DRIVER’S LICENCE
              READY BEFORE COMPLETING
              THE FORM.

            </div>

          </div>

          <div className="modern-signup-right">

            <button
              className="modern-signup-btn"
              onClick={() =>
                setShowVendorForm(true)
              }
            >

              <Send size={18} />
              Sign Up Today

            </button>

          </div>

        </div>

      </section>

      {showVendorForm && (

        <VendorFormModal
          onClose={() =>
            setShowVendorForm(false)
          }
        />
      )}

    </div>
  );
};

export default MobileTopup;